import { SET_ERROR, CLEAR_ERROR, GET_ERROR } from '../constants/actionTypes';

const initialState = { error: { message: null, statusCode: null} };

const errorReducer = (state = initialState, action) => {
        switch (action.type) {
          case SET_ERROR:
            return {
              ...state,
              error: {
                message: action.payload?.message,
                statusCode: action.payload?.statusCode || null,
              },
            };
      
          case GET_ERROR:
            return state;
      
          case CLEAR_ERROR:
            return {  ...state,  error: { message: null, statusCode: null } };
          default:
            return state;
        }
};

export default errorReducer;